let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jTfTK")).then(() => parcelRequire('1YYAh'));